module.exports = __webpack_public_path__ + "img/work-from-home.c14bff6f.webp";